import type { NavOptions } from '@app/settings/navigation';

// New hierarchical navigation structure for left sidebar
const options = [
  {
    key: 'home',
    label: 'sidebar.home',
    leftIcon: 'FaHome',
    withoutDashboard: true,
  },
  {
    key: 'crm',
    label: 'sidebar.crm',
    leftIcon: 'FaUsers',
    withoutDashboard: true,
    children: [
      {
        key: 'accounts',
        type: 'Account',
        label: 'sidebar.accounts',
        withoutDashboard: true,
      },
      {
        key: 'contacts',
        label: 'sidebar.contacts',
        withoutDashboard: true,
      },
      {
        key: 'deals',
        type: 'Deal',
        label: 'sidebar.deals',
        withoutDashboard: true,
      },
    ],
  },
  {
    key: 'commerce',
    label: 'sidebar.commerce',
    leftIcon: 'FaHandshake',
    withoutDashboard: true,
    children: [
      {
        key: 'salesdrafts',
        type: 'SalesOrder',
        label: 'sidebar.salesdrafts',
        withoutDashboard: true,
      },
      {
        key: 'salesorders',
        type: 'SalesOrder',
        label: 'sidebar.salesorders',
        withoutDashboard: true,
      },
      {
        key: 'invoicematching',
        type: 'SalesOrder',
        label: 'sidebar.invoice_matching',
        withoutDashboard: true,
      },
      {
        key: 'printavoinvoices',
        type: 'SalesOrder',
        label: 'sidebar.printavo_invoices',
        withoutDashboard: true,
      },
      {
        key: 'teamstores',
        type: 'TeamStore',
        label: 'sidebar.teamstores',
        withoutDashboard: true,
      },
      {
        key: 'purchaseorders',
        type: 'PurchaseOrder',
        label: 'sidebar.purchaseorders',
        withoutDashboard: true,
      },
      {
        key: 'purchaseorderchangerequests',
        type: 'PurchaseOrder',
        label: 'sidebar.po_change_requests',
        withoutDashboard: true,
      },
      {
        key: 'purchaseorderneedsapproval',
        type: 'PurchaseOrder',
        label: 'sidebar.po_needs_approval',
        withoutDashboard: true,
      },
    ],
  },
  {
    key: 'goods',
    label: 'sidebar.goods',
    leftIcon: 'FaBoxes',
    withoutDashboard: true,
    children: [
      {
        key: 'styles',
        type: 'Style',
        label: 'sidebar.styles',
        withoutDashboard: true,
      },
      {
        key: 'designs',
        type: 'DesignCode',
        label: 'sidebar.designs',
        withoutDashboard: true,
      },
      {
        key: 'artcodes',
        type: 'ArtCode',
        label: 'sidebar.decorations',
        withoutDashboard: true,
      },
      {
        key: 'artjobs',
        type: 'ArtJob',
        label: 'sidebar.artjobs',
        withoutDashboard: true,
      },
    ],
  },
  {
    key: 'production',
    label: 'sidebar.production',
    leftIcon: 'FaCogs',
    withoutDashboard: true,
    children: [
      {
        key: 'fulfillments',
        type: 'FulfillmentOrders',
        label: 'sidebar.fulfillmentorders',
        withoutDashboard: true,
      },
      {
        key: 'fulfillment-groups',
        type: 'FulfillmentOrders',
        label: 'sidebar.fulfillmentgroups',
        withoutDashboard: true,
      },
      {
        key: 'workorders',
        type: 'WorkOrder',
        label: 'sidebar.workorders',
        withoutDashboard: true,
      },
      {
        key: 'supplierswo',
        type: 'SupplierWorkOrder',
        label: 'sidebar.supplierworkorders',
        withoutDashboard: true,
      },
    ],
  },
  {
    key: 'warehouse',
    label: 'sidebar.warehouse',
    leftIcon: 'FaWarehouse',
    withoutDashboard: true,
    children: [
      {
        key: 'location/inventory/bins',
        label: 'sidebar.bins',
        withoutDashboard: true,
      },
      {
        key: 'location/inventory/products',
        label: 'sidebar.inventory',
        withoutDashboard: true,
      },
      {
        key: 'location/inventory/pickings',
        label: 'sidebar.picking',
        withoutDashboard: true,
      },
      {
        key: 'location/inventory/putaway',
        label: 'sidebar.putaway',
        withoutDashboard: true,
      },
      {
        key: 'location/inventory/eventreceivings',
        label: 'sidebar.receivings',
        withoutDashboard: true,
      },
    ],
  },
  {
    key: 'marketing',
    label: 'sidebar.marketing',
    leftIcon: 'FaBullhorn',
    withoutDashboard: true,
    children: [
      {
        key: 'campaigns',
        type: 'Campaign',
        label: 'sidebar.campaigns',
        withoutDashboard: true,
      },
      {
        key: 'emails',
        type: 'EmailSystem',
        label: 'sidebar.emailsystem',
        withoutDashboard: true,
      },
      {
        key: 'npssurveys',
        type: 'NpsSurvey',
        label: 'sidebar.npssurvey',
        withoutDashboard: true,
      },
    ],
  },
] as const satisfies NavOptions;

export default options;
